<template>
    <v-card color="white">
      <v-container>
        <v-row>
          <b class="help-step" style="cursor:help;" @click="show_help('', $t('file-upload.help'))">
            {{$t('file-upload.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('file-upload.help')"></span>
            </v-tooltip>
          </b>
        </v-row>
        <v-row>
          <div v-if="loadingFile === 'loading'" class="file-loading">
            <v-progress-circular
              indeterminate
              color="#15336d"
            ></v-progress-circular>
          </div>
          <div v-else-if="loadingFile === 'loaded'" style="color:green">
            {{this.$t('file-description')}}
          </div>
          <div class="input-container">
              <v-file-input
                v-model="file"
                color="#15336d"
                multiple
                prepend-icon="mdi-paperclip">
              </v-file-input>
          </div>
        </v-row>
        <v-row>
            <v-card class="file-conainer">
              <v-list two-line subheader>
                <v-subheader inset>{{this.$t('uploaded-files')}}</v-subheader>
                <v-list-item
                  v-for="(item, i) in arrFilesApi"
                  :key="item.id">
                  <v-list-item-avatar style="margin-right:0;">
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-if="item.comments">
                      <v-chip draggable x-small>
                        {{item.comments}}
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-menu
                      v-model="menu[i]"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            icon
                            @click="menu[i] = true">
                          <v-icon color="grey lighten-1">mdi-comment</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-list>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>{{$t('Step2.comment')}}</v-list-item-title>
                            </v-list-item-content>
                            
                          </v-list-item>
                        </v-list>

                        <v-divider></v-divider>

                        <v-container fluid>
                          <v-textarea
                            counter
                            label="Text"
                            rows="3"
                            v-model="text_file_comment"
                          ></v-textarea>
                        </v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click="commentFile(item.id, text_file_comment)"
                          >
                            {{$t('save')}}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                    
                   </v-list-item-action>
                  <v-list-item-action @click="downloadFile(item.name)">
                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-download</v-icon>
                    </v-btn>
                   </v-list-item-action>
                  <v-list-item-action @click="deleteFile(item.id, i)">
                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
        </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { DOMEN } from '../../../vars';

export default {
  name: 'FilesStep6',
  props: ['files_api'],

  async beforeMount() {
    this.loading = false;
  },

  mounted() {
    this.arrFilesApi.forEach(item => {
        this.fileList.push(item.id)
      })
  },

  data() {
    return {
      loadingFile:null,
      loading: true,
      fileList: [],
      arrFilesApi: this.files_api,
      file: null,
      menu: {},
      text_file_comment: '',
      message: false,
    };
  },

  watch: {
    loadingFile(val) {
      if (val === 'loaded') {
        setTimeout(() => {
            this.loadingFile = null;
            this.$emit('update_data');
        }, 500)
      }
    },

    async file(val) {
      if(val && val.length !== 0) {
        const type = val[0].name.split('.').pop();

        if (
            type === 'doc' ||
            type === 'docx' ||
            type === 'pdf' ||
            type === 'jpg' ||
            type === 'png' ||
            type === 'pptx' ||
            type === 'ppt'
        ) {
          if (val[0].size <= 6291456) {
              this.saveFile(val)
          } else {
            this.$messageHelper(this.$t('Step2.6md'), 'error')
          }
        } else {
          this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        }
      }
    },

    async fileList(val) {
      this.UPDATE_QUIZE(
          {
            files: val,
          },
        );
    },

    arrFilesApi(val) {
      if (val !== null && val.length !== 0) {
        val.forEach((item, i) => {
          this.menu[i] = false
        })
      }
    },
  },

  methods: {
    ...mapActions([
      'FILE_SEND',
      'DELETE_FILE_SYNC',
      'COMMENT_FILE_SYNC',
    ]),

    ...mapMutations([
      'UPDATE_QUIZE',
      'UPDATE_HELPER_DIALOG',
    ]),

    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    downloadFile(fileName) {
      window.open(DOMEN + `/media/${fileName}`, '_blank')
    },

    timeout() {
      setTimeout(() => {
        this.loadingFile = false
      }, 500)
    },

    async deleteFile(id, i) {
      this.DELETE_FILE_SYNC(id)
      .then(res => {
        if (res.status === 200) {
          this.arrFilesApi = this.arrFilesApi.filter(item => item.id !== Number(res.data.id))
          delete this.menu[i] 
          this.$messageHelper(this.$t('Step2.file_success_deleted'), 'success', 3000)
        }
      })
      .catch(e => {
        console.log('e',e)
      })
    },

    async commentFile(id, text) {
      this.COMMENT_FILE_SYNC({ id:id, text:text })
      .then(res => {
        
        if (res.status === 200) {
          var arrayLength = this.arrFilesApi.length;
         
          for (var i = 0; i < arrayLength; i++) {
            if ( this.arrFilesApi[i].id === res.data.id) {
              this.arrFilesApi[i].comments = text;
            }
          }
          this.text_file_comment = '';
          this.arrFilesApi.forEach((item, i) => {
          this.menu[i] = false
        })

          this.$messageHelper(this.$t('Step2.comment_added_successfully'), 'success', 3000)
        }
      })
      .catch(e => {
        his.text_file_comment = '';
        console.log('e',e)
      })
    },

    async saveFile(data) {

      this.loadingFile = 'loading'
      const files = new FormData();
      files.append('file', data[0]);

      this.FILE_SEND(files)
        .then((res) => {
          this.file = null
          this.loadingFile = 'loaded'
          this.fileList.push(res.data.id);
          
          this.addFile(data, res.data.id)
        });
    },

    addFile(file, id) {
      if (file[0] !==  undefined) {
        this.arrFilesApi.push({
          id: id,
          name: file[0].name.replaceAll(' ','_'),
          add_date: new Date(),
        });
      } 
    },
  },
};
</script>
<style scoped>

  .input-container {
    display: flex;
    flex-direction: column;
    /* height: 165px; */
    margin-top: 15px;
    width: 100%;
  }
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  .input-container.input-name {
    height: 70px;
  }

  .form-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 700px;
    width: 100%;
  }
  h4{
    color: #949494;
    letter-spacing: -0.015em;
    font-style: normal;
    font-weight: 500;
  }
  .help-step {
    margin: 0 auto 0 0;
    color: #949494;
  }
  .file-conainer{
    -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03) !important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color:white;
    margin-left:30px;
    margin-right:30px;
  }
</style>
